import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../context/AuthContext";
import { Button, Container, Spinner } from "react-bootstrap";
import { faPen, faSquarePlus, faTasks } from "@fortawesome/free-solid-svg-icons";
import { PlataformaInterface } from "../../../../interfaces/PlataformaInterface";
import { ColumnDef } from "@tanstack/react-table";
import CustomTable from "../../../Formularios/CustomTable/CustomTable";
import { API } from "../../../../global/global";
import axios from "axios";

type Plataforma = {
  id: number;
  nombre: string;
};

const PlataformasTable = () => {
  const authContext = useContext(AuthContext);
  const [plataformas, setPlataformas] = useState<PlataformaInterface[]>();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchPlataformas = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/plataforma`, {
        headers: {
          Authorization: `Bearer ${authContext.token}`,
        },
      });
      setPlataformas(response.data.data);
    } catch (error) {
      console.error("Error fetching plataformas:", error);
    } finally {
      setLoading(false);
    }
  }, [authContext.token]);

  useEffect(() => {
    fetchPlataformas();
  }, [fetchPlataformas]);

  const columns = useMemo<ColumnDef<Plataforma>[]>(
    () => [
      {
        header: "#",
        accessorKey: "id",
      },
      {
        header: "Nombre",
        accessorKey: "nombre",
      },
      {
        header: "Acciones",
        cell: ({ row }) => (
          <div>
            <Button
              variant="outline-primary"
              size="sm"
              className="me-2"
              onClick={() => navigate(`/main/catalogos/plataformas/edit/${row.original.id}`)}
            >
              <FontAwesomeIcon icon={faPen} />
            </Button>
            <Button
              variant="outline-success"
              size="sm"
              onClick={() => navigate(`/main/catalogos/plataformas/asignar/${row.original.id}`)}
            >
              <FontAwesomeIcon icon={faTasks} />
            </Button>
          </div>
        ),
      },
    ],
    [navigate]
  );

  if (loading) {
    return (
      <Container className="d-flex justify-content-center">
        <Spinner animation="grow" variant="info" />
      </Container>
    );
  }

  return (
    <Container>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1>Plataformas</h1>
        <Button
          variant="success"
          onClick={() => navigate("/main/catalogos/plataformas/crear")}
        >
          <FontAwesomeIcon icon={faSquarePlus} className="me-2" />
          Nueva Plataforma
        </Button>
      </div>
      
      {plataformas && (
        <CustomTable
          data={plataformas}
          columns={columns}
        />
      )}
    </Container>
  );
};

export default PlataformasTable;
